<template>
  <div>
    <v-icon
      size="30"
      color="grayLight"
      @click="isChooseReasons = !isChooseReasons"
    >
      mdi-dots-horizontal-circle-outline
    </v-icon>
    <div v-if="isChooseReasons" class="projects-list mb-5">
      <div class="projects-list-content">
        <div class="pt-3 pl-4 reason-title">
          <strong>Choose Reasons</strong>
        </div>
        <v-radio-group
          v-model="movingNotInterestedReason"
          active-class="active-radio"
        >
          <div
            v-for="(item, index) in notInterestedReasons"
            :key="`not-interested-${index}`"
            :title="item.title && item.title.length > 35 ? item.title : null"
          >
            <v-radio :value="item.key">
              <template slot="label">
                <span v-if="item.key !== 8" class="">{{ item.title }} </span>

                <v-text-field
                  v-if="item.key == 8"
                  v-model="not_interested_reason_other"
                  class="no-detail"
                  rows="1"
                  hide-details
                  color="#A1A5A6"
                  placeholder="Other reasons..."
                  :disabled="movingNotInterestedReason != 8"
                />
              </template>
            </v-radio>
          </div>
        </v-radio-group>
        <div class="d-flex justify-center pb-5">
          <v-btn
            color="primary"
            width="156"
            :loading="rejectionSubmitLoading"
            @click="updateCandidate"
          >
            Submit
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RejectedReasonBox',

  props: {
    candidateId: {
      type: String,
    },

    tab: String,
    projectId: String,
  },

  data() {
    return {
      notInterestedReasons: [
        {
          key: 1,
          title: 'Misclassification',
        },
        {
          key: 2,
          title: 'Timing',
        },
        {
          key: 3,
          title: 'Compensation',
        },
        {
          key: 4,
          title: 'Seniority',
        },
        {
          key: 5,
          title: 'Remote Work Policy',
        },
        {
          key: 6,
          title: 'Company Fit',
        },
        {
          key: 7,
          title: 'Work/Visa Status',
        },
        {
          key: 9,
          title: 'Role Fit',
        },
        {
          key: 8,
          title: 'Other',
        },
      ],

      movingNotInterestedReason: '',
      not_interested_reason_other: '',
      rejectionSubmitLoading: false,
      isChooseReasons: false,
    };
  },

  mounted() {
    document.body.addEventListener('click', this.onClickOutside);
  },

  beforeDestroy() {
    document.body.removeEventListener('click', this.onClickOutside);
  },

  methods: {
    updateCandidate() {
      const a = this.notInterestedReasons.find(
        (item) =>
          item.key.toString() === this.movingNotInterestedReason.toString()
      );
      this.$emit('submit', a.title);
      const payload = {
        not_interested_code: this.movingNotInterestedReason,
        not_interested_reason_other:
          this.movingNotInterestedReason === 8 ||
          this.movingNotInterestedReason === '8'
            ? this.not_interested_reason_other
            : '',
      };
      this.$store.dispatch('projects/candidates/updateCandidateState', {
        projectId: this.projectId,
        tab: this.tab,
        candidateId: this.candidateId,
        newTab: this.tab,
        payload,
      });
      this.isChooseReasons = false;
    },

    onClickOutside() {
      this.isChooseReasons = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.projects-list {
  position: absolute;
  margin-top: 10px;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  width: 260px;
  z-index: 99;
  border-radius: 4px;
  box-shadow: -2px 2px 18px rgba(0, 0, 0, 0.4);
  &__name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
::v-deep .v-input--radio-group__input > div {
  padding: 6px 16px;
}
</style>
